module.exports = __webpack_public_path__ + "img/logo-large.cd4c75da.svg";